import { CardSvg } from '@/play/cardSvg'

/** Home card art: a channel cut through the sand, the sea running into it. */
export function CanalCardArt() {
  return (
    <CardSvg bg="#dff1f3">
      {/* land */}
      <path d="M0 40 L320 40 L320 132 C 260 140, 200 126, 140 136 S 40 150, 0 140 Z" fill="#f4e8cc" />
      {/* sea, pale at the shore and deeper further out */}
      <path d="M0 140 C 40 150, 100 128, 140 136 S 260 140, 320 132 L320 200 L0 200 Z" fill="#9fd6dd" />
      <path d="M0 168 C 70 160, 150 176, 220 166 S 290 160, 320 164 L320 200 L0 200 Z" fill="#4fa9bb" />
      {/* the channel, wet walls and water running in toward a round pool */}
      <path d="M150 138 C 152 112, 132 96, 112 84" stroke="#dcc59a" strokeWidth="30" fill="none" strokeLinecap="round" />
      <path d="M150 140 C 152 112, 132 96, 112 84" stroke="#8fcfd8" strokeWidth="20" fill="none" strokeLinecap="round" />
      <ellipse cx="96" cy="74" rx="34" ry="18" fill="#dcc59a" />
      <ellipse cx="96" cy="74" rx="27" ry="13" fill="#6dbdca" />
      {/* spade */}
      <g transform="translate(212 46) rotate(28)">
        <rect x="-3" y="0" width="6" height="40" rx="3" fill="#b07a45" />
        <path d="M-15 38 h 30 v 10 a 15 15 0 0 1 -30 0 z" fill="#ff6f61" stroke="#1d2b36" strokeWidth="2.4" />
      </g>
    </CardSvg>
  )
}
